import React from "react";
import ExcelDownloader from "../../common/ExcelDownloader/ExcelDownloader";
import { getSimpleFormattedDate } from "../../../utils/utils";

const combineChildrenHeaders = (children) => {
  return children.map((child) => {
    const { id, label, type } = child;
    return { key: id, label: label, type: type || "string" };
  });
};

const generateHeaders = (columns) => {
  return columns.flatMap((column) => {
    if (column?.children) {
      return combineChildrenHeaders(column.children);
    } else {
      const { id, label, type } = column;
      return { key: id, label: label, type: type || "string" };
    }
  });
};

const ControlGLReconciliationModelerGlobalExport = ({
  columns,
  datas,
  disabled = true,
} = {}) => {
  const headers = generateHeaders(columns);

  const tableData = datas.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });
  return (
    <ExcelDownloader
      sheets={[
        {
          name: "Control_GL_Reconciliation_Modeler_Global",
          header: headers,
          data: tableData,
          showHeader: true,
        },
      ]}
      disabled={disabled}
      fileName={`ControlGLReconciliationModelerGlobal_${getSimpleFormattedDate()}.xlsx`}
    />
  );
};

export default ControlGLReconciliationModelerGlobalExport;
